"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateQuote = void 0;
var lodash_1 = require("lodash");
var CalculateSection_1 = require("./CalculateSection");
var CalculatorHelpers_1 = __importDefault(require("./CalculatorHelpers"));
function calculateQuote(blockModel, taxService, variableService, discountService, billingScheduleOrchestrator, calculateQuoteSettings, cacheResults, disableTotalsCache) {
    var _a;
    if (cacheResults === void 0) { cacheResults = false; }
    if (disableTotalsCache === void 0) { disableTotalsCache = false; }
    if (cacheResults == null) {
        cacheResults = false;
    }
    var calculatorHelpers = new CalculatorHelpers_1.default(discountService);
    var currency = blockModel.settings != null && blockModel.settings.currency != null ? blockModel.settings.currency : "AUD";
    var includeRecurringInDueToday = (_a = calculateQuoteSettings.includeRecurringInDueToday) !== null && _a !== void 0 ? _a : (blockModel.includeRecurringInDueToday || false);
    var _b = calculateSections(blockModel, variableService, discountService, billingScheduleOrchestrator, currency, includeRecurringInDueToday, cacheResults), taxable = _b.taxable, preTax = _b.preTax, quoteDiscount = _b.quoteDiscount, sectionsRecurringTotals = _b.recurringTotals, oneOffTotals = _b.oneOffTotals, cumulativeDiscount = _b.cumulativeDiscount;
    var _c = calculateTaxes(blockModel, taxService, calculatorHelpers, currency, taxable), totalTaxes = _c.totalTaxes, roundedTotalTax = _c.roundedTotalTax;
    var preDiscountTotal = calculatorHelpers.roundOffMoney(preTax, currency);
    var discountedPreTax = calculatorHelpers.roundOffMoney(calculatorHelpers.applyDiscount(preDiscountTotal, blockModel.discount), currency);
    var totalQuoteDiscount = quoteDiscount + calculatorHelpers.roundOffMoney(preDiscountTotal - discountedPreTax, currency);
    var quoteCumulativeDiscount = calculatorHelpers.roundOffMoney(preDiscountTotal - discountedPreTax, currency) + cumulativeDiscount;
    var roundedPostTax = calculatorHelpers.roundOffMoney(discountedPreTax + roundedTotalTax, currency);
    var recurringTotals = {};
    recurringTotals = (0, lodash_1.mapValues)(sectionsRecurringTotals, function (total) {
        if (total) {
            return calculateFinalQuoteTotals(blockModel, taxService, calculatorHelpers, currency, total);
        }
        else {
            return {
                preTax: 0,
                postTax: 0,
                quoteDiscount: 0,
                preDiscount: 0,
                taxes: {},
            };
        }
    });
    var totals = {
        postTax: roundedPostTax,
        preTax: discountedPreTax,
        quoteDiscount: totalQuoteDiscount,
        cumulativeDiscount: quoteCumulativeDiscount,
        totalTaxes: totalTaxes,
        preDiscount: preDiscountTotal,
        recurringTotals: recurringTotals,
        oneOffTotals: calculateFinalQuoteTotals(blockModel, taxService, calculatorHelpers, currency, oneOffTotals),
    };
    if (!disableTotalsCache) {
        blockModel.$totals = (0, lodash_1.cloneDeep)(totals);
    }
    return totals;
}
exports.calculateQuote = calculateQuote;
var calculateFinalQuoteTotals = function (blockModel, taxService, calculatorHelpers, currency, oneOffTotals) {
    var taxable = oneOffTotals.taxable, preTax = oneOffTotals.preTax, quoteDiscount = oneOffTotals.quoteDiscount;
    var _a = calculateTaxes(blockModel, taxService, calculatorHelpers, currency, taxable), totalTaxes = _a.totalTaxes, roundedTotalTax = _a.roundedTotalTax;
    var preDiscountTotal = calculatorHelpers.roundOffMoney(preTax, currency);
    var discountedPreTax = calculatorHelpers.roundOffMoney(calculatorHelpers.applyDiscount(preDiscountTotal, blockModel.discount), currency);
    var totalQuoteDiscount = quoteDiscount + calculatorHelpers.roundOffMoney(preDiscountTotal - discountedPreTax, currency);
    var roundedPostTax = calculatorHelpers.roundOffMoney(discountedPreTax + roundedTotalTax, currency);
    return {
        preTax: discountedPreTax,
        postTax: roundedPostTax,
        quoteDiscount: totalQuoteDiscount,
        preDiscount: preDiscountTotal,
        taxes: totalTaxes,
    };
};
function initialiseTotalTaxes(taxes) {
    var e_1, _a;
    var totalTaxes = {};
    try {
        for (var taxes_1 = __values(taxes), taxes_1_1 = taxes_1.next(); !taxes_1_1.done; taxes_1_1 = taxes_1.next()) {
            var tax = taxes_1_1.value;
            totalTaxes[tax.name] = 0;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (taxes_1_1 && !taxes_1_1.done && (_a = taxes_1.return)) _a.call(taxes_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return totalTaxes;
}
function calculateTaxes(blockModel, taxService, calculatorHelpers, currency, taxable) {
    var e_2, _a;
    var taxes = taxService.taxesFromBlockSettings(blockModel.settings);
    taxable = calculatorHelpers.applyDiscount(taxable, blockModel.discount);
    var totalTaxes = initialiseTotalTaxes(taxes);
    var totalTax = 0;
    try {
        for (var taxes_2 = __values(taxes), taxes_2_1 = taxes_2.next(); !taxes_2_1.done; taxes_2_1 = taxes_2.next()) {
            var tax = taxes_2_1.value;
            var value = taxable * (tax.percent / 100);
            value = calculatorHelpers.roundOffMoney(value, currency);
            totalTaxes[tax.name] = value;
            totalTax += value;
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (taxes_2_1 && !taxes_2_1.done && (_a = taxes_2.return)) _a.call(taxes_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    var roundedTotalTax = calculatorHelpers.roundOffMoney(totalTax, currency);
    return {
        totalTaxes: totalTaxes,
        roundedTotalTax: roundedTotalTax,
    };
}
function calculateSections(blockModel, variableService, discountService, billingScheduleOrchestrator, currency, includeRecurringInDueToday, cacheResults) {
    var e_3, _a;
    var taxable = 0;
    var preTax = 0;
    var quoteDiscount = 0;
    var cumulativeDiscount = 0;
    var oneOffTotals = {
        taxable: 0,
        preTax: 0,
        quoteDiscount: 0,
    };
    var useSectionSelections = false;
    var maxSelectedSections = blockModel.sections != null ? blockModel.sections.length : undefined;
    switch (blockModel.selectionType) {
        case "multi":
            useSectionSelections = true;
            break;
        case "single":
            useSectionSelections = true;
            maxSelectedSections = 1;
            break;
    }
    var selectedSectionsCount = 0;
    var recurringTotals = {};
    try {
        for (var _b = __values(blockModel.sections), _c = _b.next(); !_c.done; _c = _b.next()) {
            var section = _c.value;
            if (!useSectionSelections || section.selected === true || section.mandatory === true) {
                var totals = (0, CalculateSection_1.calculateSection)(section, variableService, discountService, billingScheduleOrchestrator, currency, cacheResults);
                taxable += totals.taxable;
                preTax += totals.preTax;
                quoteDiscount += totals.sectionDiscount;
                cumulativeDiscount += totals.cumulativeDiscount;
                oneOffTotals.preTax += totals.preTax;
                oneOffTotals.taxable += totals.taxable;
                oneOffTotals.quoteDiscount += totals.sectionDiscount;
                (0, lodash_1.mapValues)(totals.recurringTotals, function (total, frequency) {
                    if (total) {
                        if (recurringTotals[frequency]) {
                            recurringTotals[frequency].taxable += total.taxable;
                            recurringTotals[frequency].preTax += total.preTax;
                            recurringTotals[frequency].quoteDiscount += total.sectionDiscount;
                        }
                        else {
                            recurringTotals[frequency] = {
                                taxable: total.taxable,
                                preTax: total.preTax,
                                quoteDiscount: total.sectionDiscount,
                            };
                        }
                        if (includeRecurringInDueToday) {
                            taxable += total.taxable;
                            preTax += total.preTax;
                            quoteDiscount += total.sectionDiscount;
                            cumulativeDiscount += total.cumulativeDiscount;
                        }
                    }
                });
                if (section.mandatory !== true && section.selected === true) {
                    ++selectedSectionsCount;
                }
            }
            else if (cacheResults) {
                (0, CalculateSection_1.calculateSection)(section, variableService, discountService, billingScheduleOrchestrator, currency, cacheResults);
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_3) throw e_3.error; }
    }
    if (selectedSectionsCount > maxSelectedSections) {
        throw new Error("Too many selected sections");
    }
    return {
        taxable: taxable,
        preTax: preTax,
        quoteDiscount: quoteDiscount,
        recurringTotals: recurringTotals,
        oneOffTotals: oneOffTotals,
        cumulativeDiscount: cumulativeDiscount,
    };
}
